export const NEW_SESSION_MODAL_ID = 'NEW_SESSION_MODAL'
export const EDIT_SESSION_PARAMETERS_MODAL_ID = 'EDIT_SESSION_PARAMETERS_MODAL'

export const colors = ['#a26365', '#aec7e2', '#dea900', '#6098ad', '#ff979a', '#a9d3aa', '#c98354', '#98995d', '#e0b79c']
export const annotationColors = ['#566BB8', '#566BB8', '#54A656']